/** 物流费率 */
import { generate } from '@/utils/request';
const config = {
  prefix: '/schl/v1/{organizationId}/logistics/config/rate',
  items: [
      { key: 'getLogisticRate', url: '/pageList', method: 'POST' },
      { key: 'getLogisticRateSave', url: '/save', method: 'POST' },
    ],
};
export default {
  ...generate(config),
};
